export const DIGIO_IMAGE = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/digio_icon.png";
export const LOTTIE_URL = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json";
export const SHIELD_ICON = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_shield.png";
export const ACUTE_ICON = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Images/acute_icon_lg.png";
export const WORKLOAD_ICON = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Images/workload_icon_lg.png";
